import MainLayout from "@/components/layout/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "lookSchoolProfile",

    components: {
        MainLayout
    },

    data() {
        return {
            school: {},
            regionArr: RegionJson
        };
    },

    computed: {
        ...mapGetters(["schoolId", "teacherId", "studentId", "userType"]),
    },

    methods: {
        getDetailSchool() {
            axios.get("/school/profile/" + this.$route.params.id)
                .then(response => {
                    this.school = response.data;
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error, "error");
                });
        },
    },

    created() {
        this.getDetailSchool();
        fetchNotificationCount();
    }
}
